@if (showStatementOptions()) {
<ul class="st-dropdown-menu" [ngClass]="{'after-show': row.showDropdown, 'position-absolute': menuPos.mode === 'absolute'}"
    [style.top]="menuPos.offsetTop + 'px'" [style.left]="menuPos.offsetLeft > 0 ? menuPos.offsetLeft + 'px' : 'unset'"
    [style.transform]="menuPos.expandAbove ? 'translateY(-200px)' : 'translateY(2px)'" [@dropdownOpenClose]="row.showDropdown"
   >
  @for (config of filterDropdownMenuConfig(dropdownMenuConfig) | filterHidden; track $index) {
<li [class]="config.class" (click)="config.actionCallback()"
    [ngClass]="{'cursor-disabled': row.IS_FILED && config.disableIfFiled}">
    <div [ngClass]="{'disabled': row.IS_FILED && config.disableIfFiled}">
      <span class="Appkit4-icon" [ngClass]="config.iconClass"></span>
      @if (config.checkbox) {
<input type="checkbox" [(ngModel)]="row.isReviewedVal">
}
      <span>{{config.desc}}</span>
    </div>
  </li>
}
</ul>
}

@if (showRequirementOptions()) {
<ul class="st-dropdown-menu" [ngClass]="{'after-show': row.showDropdown, 'position-absolute': menuPos.mode === 'absolute'}"
    [style.top]="menuPos.offsetTop + 'px'" [style.left]="menuPos.offsetLeft > 0 ? menuPos.offsetLeft + 'px' : 'unset'"
    [style.transform]="menuPos.expandAbove ? 'translateY(-125px)' : 'translateY(2px)'" [@createDropdownOpenClose]="row.showDropdown"
   >
  @if (dstSharedService.user && dstSharedService.user.roleLevel >= 2) {
<li class="mark-na" (mouseenter)="row.showExtendedMenu = true;"
    [ngClass]="{'cursor-disabled': row.IS_FILED}">
    <div [ngClass]="{'disabled': row.IS_FILED}">
      <span class="Appkit4-icon icon-like-outline icon-placeholder"></span>
      <span>Mark as N/A</span>
      <span class="Appkit4-icon icon-right-chevron-outline mark-na-extend"></span>
    </div>
  </li>
}
  @for (config of createDropdownMenuConfig | filterHidden; track $index) {
<li (mouseenter)="row.showExtendedMenu = false;" (click)="config.actionCallback()"
    [ngClass]="{'cursor-disabled': row.IS_FILED}">
    <div [ngClass]="{'disabled': row.IS_FILED}">
      <span class="Appkit4-icon" [ngClass]="config.iconClass"></span>
      <span>{{config.desc}}</span>
    </div>
  </li>
}
</ul>
}


